import type { ComponentType } from "react";
import type { RouteComponentProps } from "react-router-dom";
import { LoginLanding } from "../components/pages/LoginLanding";
import { SignupFormHandler } from "../components/pages/SignupFormHandler";
import PasswordResetForm from "../components/forms/PasswordResetForm";
import { Completion } from "../components/pages/Completion";
import { OldSignupNotification } from "../components/pages/OldSignupNotification";
import { Signup } from "../components/pages/Signup";
import { SignupTooYoung } from "../components/forms/SignupTooYoung";
import { FormRouter } from "../components/forms/FormRouter";
import { StrongAuthSelection } from "../components/pages/StrongAuthSelection";
import type { GetCopyArguments } from "../copy";
import { routes } from "./routes";

interface RouteItem {
  path?: string;
  headerTitleKey?: GetCopyArguments;
  headerBodyKey?: GetCopyArguments;
  formComponent?: ComponentType<Record<string, never>>;
  appComponent?:
    | ComponentType<Record<string, never>>
    | ComponentType<RouteComponentProps>;
  appExact?: boolean;
  hideBodyTermsNotAccepted: boolean;
}
interface AppRouteItem extends RouteItem {
  path: string;
  appComponent:
    | ComponentType<Record<string, never>>
    | ComponentType<RouteComponentProps>;
  appExact: boolean;
}

interface HeaderRouteItem extends RouteItem {
  path: string;
  headerTitleKey: GetCopyArguments;
}

const routeArray: RouteItem[] = [
  {
    path: routes.SIGNUP_FORM_V2,
    appExact: false,
    appComponent: FormRouter,
    formComponent: SignupFormHandler,
    headerTitleKey: ["panel_signup__title"],
    headerBodyKey: ["panel_signup__body"],
    hideBodyTermsNotAccepted: true,
  },
  {
    path: routes.SIGNUP_TOO_YOUNG,
    appExact: false,
    appComponent: FormRouter,
    formComponent: SignupTooYoung,
    headerTitleKey: ["signup_too_young__title"],
    headerBodyKey: ["signup_too_young__body"],
    hideBodyTermsNotAccepted: false,
  },
  {
    path: routes.ROOT,
    appExact: true,
    appComponent: LoginLanding,
    headerTitleKey: ["panel_login_landing__title"],
    hideBodyTermsNotAccepted: false,
  },
  {
    path: routes.LOGIN,
    appExact: true,
    appComponent: StrongAuthSelection,
    headerTitleKey: ["panel_strong_auth__title"],
    headerBodyKey: ["panel_strong_auth_signup__explanation"],
    hideBodyTermsNotAccepted: false,
  },
  {
    path: routes.SIGNUP,
    appExact: true,
    appComponent: OldSignupNotification,
    headerTitleKey: ["panel_outdated_version__title"],
    headerBodyKey: ["panel_outdated_version__body"],
    hideBodyTermsNotAccepted: false,
  },
  {
    path: routes.SIGNUP_V2,
    appExact: true,
    appComponent: Signup,
    headerTitleKey: ["panel_signup__title"],
    headerBodyKey: ["panel_strong_auth_signup__explanation"],
    hideBodyTermsNotAccepted: true,
  },
  {
    path: routes.PASSWORD_RESET,
    appExact: true,
    appComponent: StrongAuthSelection,
    headerTitleKey: ["panel_strong_auth_reset_password__title"],
    headerBodyKey: ["panel_strong_auth_reset_password__body"],
    hideBodyTermsNotAccepted: false,
  },
  {
    path: routes.PASSWORD_RESET_FORM,
    appExact: false,
    appComponent: FormRouter,
    formComponent: PasswordResetForm,
    headerTitleKey: ["panel_reset_password__title"],
    hideBodyTermsNotAccepted: false,
  },
  {
    path: routes.VERIFICATIONS,
    appExact: true,
    appComponent: Completion,
    hideBodyTermsNotAccepted: false,
  },
];

export const appRouteArray = routeArray.filter((route) =>
  Boolean(route.appComponent)
) as AppRouteItem[];
export const formRouteArray = routeArray.filter((route) =>
  Boolean(route.formComponent)
);
export const headerRouteArray = (termsAccepted: boolean) =>
  routeArray
    .filter((route) => Boolean(route.path) && Boolean(route.headerTitleKey))
    .map((route) => ({
      ...route,
      ...{
        headerBodyKey: !termsAccepted && route.hideBodyTermsNotAccepted
          ? "undefined"
          : route.headerBodyKey,
      },
    })) as HeaderRouteItem[];
